import React, { useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
  useParams,
} from "react-router-dom";
import { InspirationProvider } from "./hooks/useStore";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import InspirationDrawer from "./components/InspirationDrawer";
import WhatsAppFab from "./components/WhatsAppFab";
import HomePage from "./pages/HomePage";
import PortfolioPage from "./pages/PortfolioPage";
import DesignDetailPage from "./pages/DesignDetailPage";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import BookPage from "./pages/BookPage";
import ServicesPage from "./pages/ServicesPage";
import ServiceDetailPage from "./pages/services/ServiceDetailPage";
import NotFoundPage from "./pages/NotFoundPage";
import { designs } from "./data/designs";

function ScrollToTop() {
  const { pathname } = useLocation();
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LegacyProductRedirect() {
  const { id } = useParams();
  const numericId = parseInt(id, 10);
  const design = designs.find((d) => d.id === numericId);
  return (
    <Navigate to={design ? `/portfolio/${design.slug}` : "/portfolio"} replace />
  );
}

function AppInner() {
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <div className="grain">
      <Navbar onInspirationOpen={() => setDrawerOpen(true)} />
      <ScrollToTop />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:slug" element={<ServiceDetailPage />} />

          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/portfolio/:slug" element={<DesignDetailPage />} />

          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/book" element={<BookPage />} />

          {/* Legacy redirects for SEO + bookmarks */}
          <Route path="/shop" element={<Navigate to="/portfolio" replace />} />
          <Route path="/shop/*" element={<Navigate to="/portfolio" replace />} />
          <Route path="/product/:id" element={<LegacyProductRedirect />} />
          <Route path="/wishlist" element={<Navigate to="/portfolio" replace />} />
          <Route path="/checkout" element={<Navigate to="/book" replace />} />
          <Route path="/delivery" element={<Navigate to="/about" replace />} />
          <Route path="/terms" element={<Navigate to="/about" replace />} />

          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>
      <Footer />
      <InspirationDrawer
        isOpen={drawerOpen}
        onClose={() => setDrawerOpen(false)}
      />
      <WhatsAppFab />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <InspirationProvider>
        <AppInner />
      </InspirationProvider>
    </BrowserRouter>
  );
}
